module.exports = __webpack_public_path__ + "r-v3/img/cs_person.efcc3f3f.png";